<!--
*****************************************
*										*
* NAGARRO  - CSX - CONFIDENTIAL         *
*										*
*****************************************
-->
<div class="data-container train-data-noscroll" *ngIf="trainData" [style.height.px]='trainDataHeight'>
    <lms-train-route [trainData]='trainData'></lms-train-route>
    <div class="clearfix"></div>
    <div class="train-info">
        <lms-train-ptc [trainData]='trainData'></lms-train-ptc>
        <div class="train-details-name">
            <div class="row">
                <lms-train-information [trainData]='trainData'></lms-train-information>
                <lms-train-details [trainData]='trainData'></lms-train-details>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
    <div *ngIf='!showLocmotiveGrid'>
        There are no locomotives associated with this train
    </div>
    <div class="train-data" *ngIf='showLocmotiveGrid'>
        <lms-train-loco-details-header [trainData]='trainData'></lms-train-loco-details-header>
        <div class="train-data-list" id='train-data-list'>
            <div class="train-data-scroll-area" id='loco-data-scroll' *ngIf="!trainEdit?.locoEditMode">
                <ul class="list-unstyled list-inline" id="trainEditModeWidth" *ngIf="trainData && trainData.locoDetails">
                    <li *ngFor="let loco of trainData.locoDetails; let i = index" id="{{i + 1}}" [attr.draggable]="trainEdit.draggable && !loco?.isGrayed" (drop)="drop($event, loco);" (dragstart)="dragStart($event, loco);" (dragend)="dragEnd($event, loco);" (dragenter)="dragEnter($event);"
                        (dragover)="dragOver($event)">
                        <lms-train-loco-details-data [trainData]='trainData' [topToBottom]='topToBottom' [trainEdit]='trainEdit' [id]="i" [loco]='loco' (onLocoSelect)='showLocoContextMenu($event);' [selectedTab]='selectedTab' (editAction)='editActionTrigger($event);' (actionTrigger)='actionTriggered($event);'></lms-train-loco-details-data>
                    </li>
                </ul>
            </div>

            <form id="trainDataEditFormPart" [formGroup]="trainEditForm" novalidate (ngSubmit)="saveEditableTrainData(trainEditForm, $event)" *ngIf="trainEdit?.locoEditMode">
                <div class="train-data-scroll-area" id='loco-data-scroll' formArrayName="editableLocoList">
                    <ul class="list-unstyled list-inline" id="trainEditModeWidth" *ngIf="trainData && trainData.locoDetails">
                        <li *ngFor="let loco of trainData.locoDetails; let i = index" id="{{i + 1}}" draggable="false" (drop)="drop($event, loco);" (dragstart)="dragStart($event, loco);" (dragend)="dragEnd($event, loco);" (dragenter)="dragEnter($event);" (dragover)="dragOver($event)">
                            <lms-train-loco-details-data [trainData]='trainData' [tabIndexes]='tabIndex + i*10' [group]='trainEditForm.controls.editableLocoList.controls' [topToBottom]='topToBottom' [trainEdit]='trainEdit' [id]="i" [loco]='loco' (onLocoSelect)='showLocoContextMenu($event);'
                                [formSubmitted]='formSubmitted' [locoUpdateErrors]='locoUpdateErrors' [selectedTab]='selectedTab' (editAction)='editActionTrigger($event);' (actionTrigger)='actionTriggered($event);'></lms-train-loco-details-data>
                        </li>
                    </ul>
                </div>
                <button form="trainDataEditFormPart" type="submit" style="visibility: hidden;" id="trainEditSubmitBtn"></button>
            </form>
            <div class="table-scoller">
                <div (click)="scrollLocos(true)" class='{{displayLeftArrow()}}'>
                    <img [src]="imagesPath.arrow.blackCircle.left" style="width:40px; height:40px; cursor: pointer;"></div>
                <div (click)="scrollLocos(false)" class='{{displayRightArrow()}}'>
                    <img [src]="imagesPath.arrow.blackCircle.right" style="width:40px; height:40px; cursor: pointer;"></div>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
</div>